module.exports = function () {
  return new Worker(__webpack_public_path__ + "668189f7f388356c8baa.worker.js");
};